import React from 'react';



const MessageA17 = (props) => {


    return(
        <div>{props.item.text}</div>
    )
}

export default MessageA17;
